export const LANG = {
  STORAGE_NAME: 'selected-language'
}